import {ChangeDetectionStrategy, Component, HostBinding, Input, OnInit} from "@angular/core";

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'ds-tab-content',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ds-tab-content.component.html',
  styleUrls: ['./ds-tab-content.component.scss'],
  standalone: true
})
export class DsTabContentComponent implements OnInit {

  @HostBinding('class.ds-tab-content-host_active') public isActive: boolean;

  @Input() tabId: string | string[];
  @Input('activeTabId')
  get activeTabId(): string {
    return this._activeTabId;
  }
  set activeTabId(value: string) {
    this._activeTabId = value;
    this.updateIsActive();
  }

  private _activeTabId: string;

  ngOnInit(): void {
    this.updateIsActive();
  }

  private updateIsActive(): void {
    this.isActive = !this.tabId || this.tabId === this.activeTabId;
  }

}
